<template>
  <b-tabs>
    <b-tab>
      <template slot="title">
        <i class='icon-settings'></i>
      </template>
      <div class="p-3">
        <h6>Settings</h6>
        <div class="aside-options">
          <div class="clearfix mt-4">
            <small><b>Editer Mode</b></small>
            <c-switch color="success" @change="toggleEditorMode" label variant="pill" size="sm" class="float-right" v-model="editorMode"  />
          </div>
          <div>
            <small class="text-muted"> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</small>
          </div>
        </div>
        <hr>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue';
export default {
  components: {
    cSwitch
  },
  data () {
    return {
      editorMode: false
    };
  },
  methods: {
    toggleEditorMode () {
      this.$store.dispatch('changeEditorMode', this.editorMode);
    }
  }
};
</script>
